module.exports = __webpack_public_path__ + "static/stronger-return-5167e31377f901d964a7b2322bfb2cb8.png";